export const PART_SEARCH_INPUT_ID = 'part-search-input';
export const PART_SEARCH_SUBMIT_ID = 'part-search-submit';
export const PART_SEARCH_CLEARANCE_FILTER_ID = 'part-search-clearance-filter';

export const PART_SEARCH_RESULT_CLASS = 'part-search-result';
export const PART_SEARCH_CATEGORY_CLASS = 'part-search-category';
export const PART_SEARCH_ADD_TO_QUOTE_CLASS = 'part-search-add-to-quote';
export const PART_SEARCH_PRODUCT_DETAILS_CLASS = 'part-search-product-details';
export const PART_SEARCH_QUANTITY_CLASS = 'part-search-quantity';
